<div class="clone-kr-modal-wrapper" data-test-id="clone-okrs">
  <div class="metric-wrapper">
    <i class="fs-16px" uiTheme="fill" uiType="metric" ui-icon></i>
    <span class="sp-ml-5 fs-16px font-mediumbold">{{ metric.name }}</span>
  </div>

  <p class="sp-pt-20 sp-mb-4 fs-12px text-color-gray-13">{{ "clone_to" | localize }}</p>

  <!-- Goal selector -->
  <div class="open-goal-selector-wrapper" (click)="openGoalSelector()" data-test-id="open-goal-selector-modal-clone">
    <div class="selected-goal-input cursor-pointer fs-14px" *ngIf="!selectedModalOptions.goal">
      {{ "search_okr" | localize }}
    </div>

    <div class="selected-goal-input cursor-pointer" *ngIf="selectedModalOptions.goal">
      <i class="fs-16px" uiTheme="fill" uiType="goal" ui-icon></i>
      <span class="sp-ml-5 text-color-gray-13 fs-14px" ui-typography uiEllipsis>{{ selectedModalOptions.goal.name }}</span>
    </div>
  </div>

  <!-- Selected session  -->
  <p class="sp-mb-4 sp-mt-20 text-color-gray-13 fs-12px" *ngIf="selectedModalOptions.goal">{{ "in_session" | localize }}</p>

  <div class="selected-goal-input non-selectable-session" *ngIf="selectedModalOptions.session">
    <i class="fs-16px" uiTheme="fill" uiType="session" ui-icon></i><span class="sp-ml-5 text-color-gray-13 fs-14px" ui-typography uiEllipsis>{{ selectedModalOptions.session.title }}</span>
  </div>

  <!-- Checkboxes -->
  <ui-checkbox-wrapper class="sp-mb-24" (checkboxWrapperOnChange)="validateSelectedOptions()" data-test-id="kr-clone-modal-checkbox-wrapper">
    <div class="sp-mt-20">
      <label class="font-medium" [(ngModel)]="selectedModalOptions.progress" [uiDisabled]="isDynamicMetric" uiValue="progress" ui-checkbox>{{ "keep_kr_progress" | localize }}</label>
      <div class="sp-mt-2 sp-pl-24 text-color-gray-9" *ngIf="isDynamicMetric">{{ "keep_kr_progress_info" | localize }}</div>
    </div>
    <div class="sp-mt-20" *ngIf="isDynamicMetric">
      <label class="font-medium" [(ngModel)]="selectedModalOptions.duplicateInsight" [uiDisabled]="selectedModalOptions.sync" uiValue="duplicateInsight" ui-checkbox>{{
        "duplicate_insight_kr" | localize
      }}</label>
      <div class="sp-mt-2 sp-pl-24 text-color-gray-9">{{ "duplicate_insight_kr_info" | localize }}</div>
    </div>
    <div class="sp-mt-20">
      <label class="font-medium" [(ngModel)]="selectedModalOptions.sync" [uiDisabled]="selectedModalOptions.duplicateInsight || !this.selectedModalOptions.progress" uiValue="sync" ui-checkbox>{{
        "keep_progress_and_updates_in_sync" | localize
      }}</label>
      <div class="sp-mt-2 sp-pl-24 text-color-gray-9">{{ "keep_progress_and_updates_in_sync_desc" | localize }}</div>
    </div>
    <div class="sp-mt-20">
      <label class="font-medium" [(ngModel)]="selectedModalOptions.notifications" uiValue="notifications" ui-checkbox>{{ "send_notification_to_owner" | localize }}</label>
    </div>
  </ui-checkbox-wrapper>
</div>
